import * as React from "react";
import { Location } from "history";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";
import { Product } from "@linkfluence/models/product";
import {
  isAuthenticated,
  redirectToInitialPage,
  redirectToLogin,
} from "@linkfluence/visa/auth";
import { setAuthToken, setRefreshToken } from "@linkfluence/visa/tokens";
import { parse } from "@tootools/query-string";
import { Container as NotificationContainer } from "@ui-kit/notification";

const RedirectToLogin = ({ client, redirect }) => {
  redirectToLogin(client, redirect);
  return null;
};

type IProps = RouteComponentProps<{ [key: string]: string }> & {
  refresher: (location: Location, nextLocation: Location) => boolean;
  location: Location;
  loader: React.ReactNode;
  children: React.ReactNode;
  client: Product;
};

class Component extends React.Component<IProps> {
  public static displayName = "Linkfluence/router";
  public shouldComponentUpdate(nextProps) {
    if (this.props.refresher) {
      return this.props.refresher(this.props.location, nextProps.location);
    } else {
      return nextProps.location.pathname !== this.props.location.pathname;
    }
  }

  public render() {
    const search = window.location.search;
    const {
      token,
      refresh_token,
      redirect = "/",
    } = parse(search) as {
      token: string;
      refresh_token: string;
      redirect: string;
    };

    const { loader, client, children } = this.props;
    return (
      <React.Suspense fallback={loader ? loader : <div>Loading...</div>}>
        <React.Fragment>
          <Switch>
            <Route
              path="/"
              exact
              component={() => {
                if (token && refresh_token) {
                  // is Authenticating
                  setAuthToken(token);
                  setRefreshToken(refresh_token);
                  redirectToInitialPage(redirect);
                }
                return null;
              }}
            />
            <Route path="/login">
              {isAuthenticated() ? (
                <Redirect to="/" />
              ) : (
                <RedirectToLogin client={client} redirect={redirect} />
              )}
            </Route>
          </Switch>
          {children}
          <NotificationContainer />
        </React.Fragment>
      </React.Suspense>
    );
  }
}

export default withRouter(Component);
